<template>
  <div class="filter-wrapper">
    <a-form :model="filterData">
      <div class="df">
        <div class="btn-wrapper">
          <a-button class="mr10" type="primary" @click="initList"
            >查询</a-button
          >
          <!-- <a-button @click="resetFilter">重置</a-button> -->
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  margin-bottom: 10px;
}
.btn-wrapper {
  margin-left: auto;
}
</style>
